import { useMemo } from "react";
import { Fields } from "src/types";
import { sortFields } from "../utils";

export const useSortedFieldEntries = (fields: Fields) =>
  useMemo(() => sortFields(fields), [fields]);
